﻿export const AppContainerId = 'veilederRenter';